import React, { useEffect } from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import { toast } from 'react-toastify';
import { CLOTHESTYPE } from '../../../../enums';
import { FirefighterService } from '../../../../services';
import type { Clothing, Firefighter } from '../../../../types';
import { SimpleBox } from '../../../atoms';

export function Member(): React.JSX.Element {
  const navigate = useNavigate();
  const { firefighterId } = useParams();

  const [isLoading, setIsLoading] = React.useState(true);
  const [member, setMember] = React.useState<Firefighter & { clothes: Clothing[] }>();

  const loadFirefighter = async () => {
    if (firefighterId) {
      const firefighterResponse = await FirefighterService.getFirefighterById(firefighterId);
      if (firefighterResponse.error) {
        toast.error('Fehler beim Laden des Mitgliedes 😩');
        console.log(firefighterResponse.message);

        return;
      }
      setMember(firefighterResponse.data as Firefighter & { clothes: Clothing[] });
      setIsLoading(false);
    }
  };

  const getClothingTypeName = (type: CLOTHESTYPE): string => {
    if (type === CLOTHESTYPE.JACKE) {
      return 'Jacke';
    }
    if (type === CLOTHESTYPE.AGT_HOSE) {
      return 'AGT-Hose';
    }
    if (type === CLOTHESTYPE.BUNDHOSE) {
      return 'Bundhose';
    }
    if (type === CLOTHESTYPE.LATZHOSE) {
      return 'Latzhose';
    }

    return 'XXXXXXX';
  };

  const handleClothinTableClick = (id: string): void => {
    navigate(`/kleidung/${id}`, { replace: false });
  };

  useEffect(() => {
    loadFirefighter().then(() => {});
  }, []);

  if (isLoading) {
    return <></>;
  }

  return (
    <div className={'container mt-10'}>
      <div className='row'>
        <div className='col-8'>
          <SimpleBox>
            <h4>Mitglied</h4>
            <div>
              Name: {member?.firstname} {member?.lastname}
            </div>
          </SimpleBox>
        </div>
        <div className='col-4'>
          <SimpleBox>
            <h4>Infos</h4>
            <h6>Kleidungsstücke: {member?.clothes.length}</h6>
          </SimpleBox>
        </div>
      </div>
      <div className='row mt-4'>
        <div className='col-12'>
          <SimpleBox>
            <h4>Kleidung</h4>
            <table className='table table-hover'>
              <thead>
                <tr>
                  <th scope='col'>#</th>
                  <th scope='col'>Typ</th>
                  <th scope='col'>Name</th>
                  <th scope='col'>Code</th>
                </tr>
              </thead>
              <tbody>
                {member?.clothes.map((clothe, index) => (
                  <tr key={clothe.id} className='cursor-pointer' onClick={() => handleClothinTableClick(clothe.id)}>
                    <th scope='row'>{index + 1}</th>
                    <td>{getClothingTypeName(clothe.type)}</td>
                    <td>{clothe.name}</td>
                    <td>{clothe.code}</td>
                  </tr>
                ))}
              </tbody>
            </table>
          </SimpleBox>
        </div>
      </div>
    </div>
  );
}
